import { Pipe, PipeTransform } from '@angular/core';
import { PricePolicyType } from 'src/app/features/prices/price-policies/interfaces/price-policy';

@Pipe({
  name: 'translatePricePolicyType',
})
export class TranslatePricePolicyTypePipe implements PipeTransform {
  transform(type: PricePolicyType | string): string {
    switch (type) {
      case PricePolicyType.FixedWithOkMeter:
      case 'FixedWithOkMeter':
        return 'Fast med OK-måler';
      case PricePolicyType.FixedWithoutOkMeter:
      case 'FixedWithoutOkMeter':
        return 'Fast uden OK-måler';
      case PricePolicyType.Dynamic:
      case 'Dynamic':
        return 'Dynamisk';
      default:
        return String(type);
    }
  }
}
